// extracted by mini-css-extract-plugin
module.exports = {"mobilePopup":"GithubPopup_mobilePopup__FKeVw","desktopPopup":"GithubPopup_desktopPopup__yFGtn"};